import React from "react";
import { createPortal } from "react-dom";
import { X } from "lucide-react";

export default function DashboardRadarConfirmModal({
  radarConfirmData,
  onClose,
  onConfirm,
  checkIcon,
}) {
  if (!radarConfirmData) return null;

  return createPortal(
    <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4" onClick={onClose}>
      <div className="bg-[#FAFAFA]/95 backdrop-blur-2xl rounded-[2.5rem] w-full max-w-sm relative shadow-2xl border border-white/60 overflow-hidden" onClick={(e) => e.stopPropagation()}>
        <div className="h-28 relative overflow-hidden bg-gradient-to-br from-green-100 to-emerald-50">
          <div className="absolute top-[-20%] right-[-10%] w-32 h-32 rounded-full bg-white/20 blur-xl"></div>
          <button onClick={onClose} className="absolute top-5 right-5 p-2 bg-white/40 hover:bg-white/80 active:scale-95 backdrop-blur-md rounded-full text-gray-600 transition shadow-sm border border-white/20 z-10">
            <X size={20} />
          </button>
        </div>
        <div className="px-6 relative -mt-10 mb-4 flex flex-col items-center text-center">
          <div className="w-20 h-20 rounded-[2rem] bg-white shadow-[0_8px_30px_rgba(0,0,0,0.08)] flex items-center justify-center border-4 border-white/80 mb-3">
            <img src={checkIcon} alt="check" className="w-10 h-10 object-contain" />
          </div>
          <h3 className="text-xl font-black text-[#2C3E30] font-do-hyeon">목양 완료</h3>
        </div>
        <div className="px-6 pb-6 text-center space-y-4">
          <p className="text-sm text-gray-600 font-medium leading-relaxed">
            <span className="font-bold text-[#354F38]">{radarConfirmData.actionName}</span> 활동을<br />
            정성껏 마치셨나요? 😊<br />
            <span className="text-xs text-gray-400 mt-1 block">수고한 사역자님을 위해 기록을 정리해 드릴게요.</span>
          </p>
          <div className="flex gap-2">
            <button onClick={onClose} className="flex-1 py-3 bg-gray-100 text-gray-500 rounded-2xl font-bold hover:bg-gray-200 transition text-sm">취소</button>
            <button onClick={onConfirm} className="flex-1 py-3 bg-[#354F38] text-white rounded-2xl font-bold hover:bg-[#2C3E30] transition shadow-lg text-sm">완료 처리</button>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
}
